<div fxLayoutAlign="center center" style="margin-top: 20px">
  <mat-spinner [color]="color"></mat-spinner>
</div>
